import React, { Component } from "react";
import "./Header.css";
import GreenCLogo from "../../../Images/GreenCLogo.svg";
import EqualizerIcon from "@material-ui/icons/Equalizer";
import { withRouter } from "react-router-dom";
import { Button } from "react-bootstrap";

class Header extends Component {
  swedishFlag = (
    <img
      className="flagIcon"
      onClick={() => this.props.setLanguage("swedish")}
      src={require("../../../Images/Icons/swedenFlagIcon.svg")}
      alt="swedenFlagIcon"
    ></img>
  );
  englishFlag = (
    <img
      className="flagIcon"
      onClick={() => this.props.setLanguage("english")}
      src={require("../../../Images/Icons/englandFlagIcon.svg")}
      alt="englandFlagIcon"
    ></img>
  );

  handleProfileClick = () => {
    this.props.history.push("/ProfileScreen");
  };

  handleLogoClick = () => {
    var path = JSON.stringify(this.props.location.pathname);

    path = path.split("/");
    path = path[1].split('"');
    var pathName = path[0];

    if (pathName === "ProfileScreen" || pathName === "ItemScreen") {
      this.props.history.push("/MainScreen");
    }
  };

  render() {
    let btnDisplay = { display: "none" };
    let flagIcon = this.swedishFlag;

    if (this.props.isLoggedIn) {
      btnDisplay = { display: "block" };
    } else {
      btnDisplay = { display: "none" };
      if (this.props.language === "english") {
        flagIcon = this.swedishFlag;
      } else {
        flagIcon = this.englishFlag;
      }
    }

    return (
      <div
        className="header"
        style={
          this.props.showBackBtn
            ? { position: "fixed", zIndex: "10", top: "0px" }
            : {}
        }
      >
        {this.props.showBackBtn && (
          <Button
            id="headerBackBtn"
            variant="light"
            onClick={() => this.props.history.goBack()}
          >
            <img
              src={require("../../../Images/Icons/back.svg")}
              alt="backIcon"
            ></img>
          </Button>
        )}
        {this.props.showStatsBtn && (
          <Button
            id="headerBackBtn"
            variant="light"
            onClick={() => this.props.history.push("/ReportScreen")}
          >
            <EqualizerIcon style={{ color: "white" }} />
          </Button>
        )}

        <img
          onClick={() => this.handleLogoClick()}
          src={GreenCLogo}
          alt="GreenCobra"
          id="GreenCobraLogo"
        ></img>

        {this.props.showFlagIcon ? flagIcon : null}
        {this.props.showSettingsIcon && (
          <img
            id="headerSettingsBtn"
            variant="light"
            onClick={() => this.props.onProfileClick()}
            style={btnDisplay}
            src={require("../../../Images/Icons/settings.svg")}
            alt="profileIcon"
          ></img>
        )}
      </div>
    );
  }
}
export default withRouter(Header);
